import { useState } from 'react';
import Logo from 'components/icons/Logo';
import { useNavigate } from 'react-router-dom';
import Input from 'components/common/Input';
import Button from 'components/common/Button';
import Colors from 'assets/Colors.js';
import LanguageSelector from 'containers/SideBarTopMenuHOC/LanguageSelector';
import { Carousel, Col, Row } from 'antd';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import useScreenSize from 'hooks/useScreenSize';
import { useRealmApp } from 'RealmApp';
import Footer from 'components/common/Footer';
import { useTranslation } from 'react-i18next';
import onboarding3 from '../../assets/images/onboarding3.png';
import onboarding2 from '../../assets/images/onboarding2.png';
import onboarding1 from '../../assets/images/onboarding1.png';
import wallpaper from '../../assets/images/LoginBackground.png';
import s from './styles';

function PasswordChangeRequest() {
  const { t } = useTranslation();
  const app = useRealmApp();
  const navigate = useNavigate();

  const [emailSent, setEmailSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const { values, handleSubmit, getFieldProps, isValid } = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email('Invalid email address').required('Required'),
    }),
    onSubmit: (values) => {
      setLoading(true);
      app.emailPasswordAuth
        // password is just a placeholder, do not change
        .callResetPasswordFunction(values.email, '123456')
        .then(() => {
          setEmailSent(true);
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
          navigate('/500');
          setLoading(false);
        });
    },
  });

  const { height } = useScreenSize();

  return (
    <>
      <s.headerContainer>
        <a href="/">
          <Logo />
        </a>
        <LanguageSelector login />
      </s.headerContainer>

      <Row>
        <Col xs={24} md={12}>
          <s.formContainer>
            <s.form>
              {emailSent ? (
                <s.Title>{t('containers.RecoverPassword.checkEmail')}</s.Title>
              ) : (
                <s.Title>
                  {t('containers.RecoverPassword.recoverPassword')}
                </s.Title>
              )}
              <s.line />

              {/* ******* */}
              {emailSent ? (
                <>
                  <s.SubTitle style={{ marginTop: '36px' }}>
                    {t('containers.RecoverPassword.checkEmailMessage')}
                  </s.SubTitle>
                  <Button
                    onClick={() => {
                      navigate('/login');
                    }}
                    type="primary"
                    style={{
                      background: Colors.primary_web,
                      color: Colors.text_on_secondary,
                      marginTop: '20px',
                    }}
                  >
                    {t('containers.RecoverPassword.login')}
                  </Button>
                </>
              ) : (
                <>
                  <s.SubTitle style={{ marginTop: '36px' }}>
                    {t('containers.RecoverPassword.enterEmail')}
                  </s.SubTitle>
                  <Input
                    placeholder={t('containers.RecoverPassword.email')}
                    style={{
                      marginBottom: '20px',
                    }}
                    {...getFieldProps('email')}
                  />
                  {isValid && values.email.length >= 1 ? (
                    <Button
                      loading={loading}
                      type="primary"
                      onClick={handleSubmit}
                      style={{
                        background: Colors.primary_web,
                        opacity: isValid && values.email.length >= 1 ? 1 : 0.5,
                        color: Colors.text_on_secondary,
                      }}
                    >
                      {t('containers.RecoverPassword.restore')}
                    </Button>
                  ) : (
                    <Button
                      loading={loading}
                      type="primary"
                      onClick={handleSubmit}
                      disabled
                      style={{
                        background: Colors.primary_web,
                        opacity: isValid && values.email.length >= 1 ? 1 : 0.5,
                        color: Colors.text_on_secondary,
                      }}
                    >
                      {t('containers.RecoverPassword.restore')}
                    </Button>
                  )}
                </>
              )}
            </s.form>
            {!emailSent && (
              <s.NoAccountText href="/login">
                {t('containers.RecoverPassword.rememberPassword')}

                <p
                  style={{
                    marginLeft: '3px',
                    fontWeight: '400',
                    fontSize: '16px',
                  }}
                >
                  <s.register href="/login">
                    {t('containers.RecoverPassword.login')}
                  </s.register>
                </p>
              </s.NoAccountText>
            )}
          </s.formContainer>
        </Col>
        <Col
          xs={0}
          md={12}
          style={{
            backgroundImage: `url(${wallpaper})`,
            minHeight: '100vh',
            height: 'auto',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <Carousel
            autoplay
            style={{
              height: height < 687 ? '687px' : '100vh',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div style={{}}>
              <s.imageContainer>
                <img
                  src={onboarding1}
                  style={{ maxWidth: '500px', width: '100%' }}
                />
              </s.imageContainer>
              <s.textContainer>
                <div
                  style={{ width: '50%', textAlign: 'center', color: 'white' }}
                >
                  <s.TitleLeft>
                    {t('containers.RecoverPassword.onboardingTitle')}
                  </s.TitleLeft>
                  <s.SubTitleRight>
                    {t('containers.RecoverPassword.onboardingMessage')}
                  </s.SubTitleRight>
                </div>
              </s.textContainer>
            </div>
            <div style={{}}>
              <s.imageContainer>
                <img
                  src={onboarding2}
                  style={{ maxWidth: '500px', width: '100%' }}
                />
              </s.imageContainer>
              <s.textContainer>
                <div
                  style={{ width: '50%', textAlign: 'center', color: 'white' }}
                >
                  <s.TitleLeft>
                    {t('containers.RecoverPassword.onboardingTitle2')}
                  </s.TitleLeft>
                  <s.SubTitleRight>
                    {t('containers.RecoverPassword.onboardingMessage2')}
                  </s.SubTitleRight>
                </div>
              </s.textContainer>
            </div>
            <div style={{}}>
              <s.imageContainer>
                <img
                  src={onboarding3}
                  style={{ maxWidth: '500px', width: '100%' }}
                />
              </s.imageContainer>
              <s.textContainer>
                <div
                  style={{ width: '50%', textAlign: 'center', color: 'white' }}
                >
                  <s.TitleLeft>
                    {t('containers.RecoverPassword.onboardingTitle3')}
                  </s.TitleLeft>
                  <s.SubTitleRight>
                    {t('containers.RecoverPassword.onboardingMessage3')}
                  </s.SubTitleRight>
                </div>
              </s.textContainer>
            </div>
          </Carousel>
        </Col>
      </Row>
      <Footer marginTop="-50px" />
    </>
  );
}

export default PasswordChangeRequest;
